import { cdate } from 'cdate';
const cdateJST = cdate().utcOffset(9).locale('ja').cdateFn();

export { cdateJST };
